export function GridSelector() {
  return {
    rows: 0,
    cols: 0,

    // Actions
    highlight(r: number, c: number) {
      this.rows = r;
      this.cols = c;
    },

    reset() {
      this.rows = 0;
      this.cols = 0;
    },

    select(editorStore: any) {
      if (this.rows > 0 && this.cols > 0) {
        editorStore.insertTable(this.rows, this.cols);
        // Reset after insertion
        this.reset();
        // Blur to close dropdown
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur();
        }
      }
    },

    // Helpers
    getLabel(i18n: any) {
      if (this.rows > 0) {
        return `${this.rows} x ${this.cols}`;
      }
      return i18n && i18n.table ? i18n.table : "Insert Table";
    },

    isActive(r: number, c: number) {
      return r <= this.rows && c <= this.cols;
    },
  };
}
